export default "__VITE_ASSET__CqCOkw2C__"